/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_No_Models_DescriptionInputs */



/**
* | output |
* | --- |
* | "Add a private model to connect your self-hosted LLM to oneAI." |
*
* @param {Private_Models_No_Models_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_no_models_description = /** @type {((inputs?: Private_Models_No_Models_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_No_Models_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fügen Sie ein privates Modell hinzu, um Ihr selbst gehostetes LLM mit oneAI zu verbinden.")
	return /** @type {LocalizedString} */ ("Add a private model to connect your self-hosted LLM to oneAI.")
});